import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { ScrapingState, ScrapingOwner } from '../types'
import { getOwnerStats } from './helpers'

const noScrapingConfig = {
  owners: [],
  activeState: null,
  isInitalized: false,
  isLoading: true,
  hasError: false,
}

interface SetStatsPayload {
  owners: ScrapingOwner[]
  state: string
}

const initialState: ScrapingState = { ...noScrapingConfig }

export const scrapingSlice = createSlice({
  name: 'Scraping',
  initialState,
  reducers: {
    fetchStats: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setStats: (state, action: PayloadAction<SetStatsPayload>) => {
      state.owners = action.payload.owners
      state.activeState = action.payload.state
      state.isLoading = false
      state.isInitalized = true
      state.hasError = false
    },
    fetchStatsFailed: (state) => {
      state.owners = []
      state.isInitalized = false
      state.isLoading = false
      state.hasError = true
    },
  },
})

export const fetchOwnerStats = (state: string) => async (dispatch) => {
  try {
    dispatch(fetchStats())
    const owners = await getOwnerStats(state)
    dispatch(
      setStats({
        state,
        owners,
      }),
    )
  } catch (error) {
    message.error('Error gettings stats')
    dispatch(fetchStatsFailed())
  }
}

// Actions
export const { fetchStats, setStats, fetchStatsFailed } = scrapingSlice.actions

export default scrapingSlice.reducer
